<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M18.56 4.13a7.998 7.998 0 014.731.581 1.143 1.143 0 01.337 1.85l-4.3 4.299 1.812 1.812 4.3-4.3a1.143 1.143 0 011.849.337 7.998 7.998 0 01-9.834 10.88l-7.367 7.366a3.566 3.566 0 11-5.043-5.043l7.367-7.367A8 8 0 0118.56 4.13z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsToolFilled'
}
</script>
